"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startAnimationLoop = void 0;
const framerate_limiter_1 = require("./framerate_limiter");
/**
 * Use requestVideoFrameCallback if available so the video framerate and animation framerate are synchronized.
 * Otherwise we fallback to a 30fps framerate, which is what our in-call video most often uses.
 * returns a function to stop the animation
 * @param videoFrameCallback The function to call per animation frame
 * @param videoElement The video element to synchronizewith
 */
function startAnimationLoop(videoFrameCallback, videoElement) {
    if ('requestVideoFrameCallback' in HTMLVideoElement.prototype &&
        'cancelVideoFrameCallback' in HTMLVideoElement.prototype) {
        const requestCallbackLoop = () => {
            videoFrameCallback(videoElement);
            videoElement.requestVideoFrameCallback(requestCallbackLoop);
        };
        const callbackId = videoElement.requestVideoFrameCallback(requestCallbackLoop);
        return () => videoElement.cancelVideoFrameCallback(callbackId);
    }
    else {
        const frameScheduler = new framerate_limiter_1.FramerateLimiter(() => videoFrameCallback(videoElement), 30);
        frameScheduler.start();
        return () => frameScheduler.stop();
    }
}
exports.startAnimationLoop = startAnimationLoop;
//# sourceMappingURL=start_animation_loop.js.map